import { Logo } from "../data/logo";

export function LogoSvg() {
    return <Logo />;
}
